import styled from "@emotion/styled";

import { H2Container, H3Container } from "shared/components/content/content-summary/styles";
import { fontMerriweather, fontRoboto, fontRobotoCondensed, theme } from "shared/lib/styles";

import { FlexContainer as ContentActionBar } from "scmp-app/components/content/content-action-bar/styles";
import { Flag } from "scmp-app/components/content/content-headline/content-headline-tag/styles";
import {
  Headline as ContentHeadline,
  SponsorHeadline,
} from "scmp-app/components/content/content-headline/styles";
import { StyledTopicLink } from "scmp-app/components/content/content-topic-link/styles";
import { EntityLink } from "scmp-app/components/entity-link";
import { MyDailyFiveNumber } from "scmp-app/components/my-news/my-daily-five/my-daily-five-number";

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  inline-size: 100%;
  margin-block-end: 20px;
  padding-block-end: 20px;
  border-block-end: 1px solid #e9e9e9;
  &:last-child {
    margin-block-end: 24px;
    padding-block-end: 0;
    border-block-end: 0;
  }

  ${theme.breakpoints.up("tablet")} {
    inline-size: auto;

    &:nth-child(2),
    &:nth-child(4) {
      margin-block-end: 0;
      padding-block-end: 0;
      border-block-end: 0;
    }
  }

  ${theme.breakpoints.up("desktop")} {
    margin-block-end: 20px;
    padding-block-end: 20px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  ${theme.breakpoints.up("tablet")} {
    flex: auto;
  }
`;

export const ContentWrapper = styled.div`
  flex: 1;

  margin-block-end: 13.5px;
  margin-inline-end: 12px;
  ${theme.breakpoints.up("tablet")} {
    margin-inline-end: 0;
  }
`;

export const TopicLink = styled.div`
  ${StyledTopicLink} {
    margin-block-end: 8px;

    color: #000000;
    font-weight: 700;
    font-size: 14px;
    font-family: ${fontRobotoCondensed};
    line-height: 16.41px;
  }
`;

export const Headline = styled.div`
  ${ContentHeadline} {
    color: #000000;
  }

  ${ContentHeadline}, ${SponsorHeadline}, ${Flag} {
    font-size: 16px;
    font-family: ${fontMerriweather};
    line-height: 140%;

    ${theme.breakpoints.up("tablet")} {
      font-size: 15px;
    }
  }
`;

export const ActionBar = styled.div`
  inline-size: 100%;
  ${ContentActionBar} {
    margin-block-start: 12px;
    ${theme.breakpoints.up("tablet")} {
      margin-block-start: 0;
    }
    time {
      color: #999999;
      font-size: 12px;
      line-height: 14px;
    }
  }
`;

export const StyledNumber = styled(MyDailyFiveNumber)`
  margin-inline-end: 18px;
  ${theme.breakpoints.up("tablet")} {
    margin-inline-end: 16px;
  }
`;

export const CoverContainer = styled.div`
  figure {
    inline-size: 80px;
    block-size: 80px;
    ${theme.breakpoints.up("tablet")} {
      inline-size: 70px;
      block-size: 70px;
    }
  }
  ${theme.breakpoints.up("tablet")} {
    display: flex;
    flex-wrap: nowrap;

    inline-size: 100%;
    margin-block-end: 16px;
  }
`;

export const Summary = styled.div`
  ${H2Container}, ${H3Container} {
    display: none;
    flex: 1;

    color: #666666;
    font-size: 14px;
    font-family: ${fontRoboto};
    line-height: 130%;

    ${theme.breakpoints.up("tablet")} {
      display: block;

      margin-inline-end: 8px;
    }
  }
`;

export const CoverEntityLink = styled(EntityLink)`
  display: block;

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const Cover = styled.div`
  figure {
    border-radius: 8px;

    overflow: hidden;
  }
`;
